import { render, staticRenderFns } from "./ApplyCredits.vue?vue&type=template&id=c0a7637c&scoped=true"
import script from "./ApplyCredits.vue?vue&type=script&lang=js"
export * from "./ApplyCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a7637c",
  null
  
)

export default component.exports